import env from './env.js'

import RestApiFactory from './services/restApiFactory'

let restApi = RestApiFactory.createRestApi(env.apiUrl())

export default restApi

export let feedApi = RestApiFactory.createRestApi(env.feedApiUrl())
